let _ = t => t,
  _t;
// eslint-disable-next-line
import { css, isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { useMemo } from 'react';
import styled from 'styled-components';
import MenuItem from '../../../components/Menu/components/MenuItem';
import { getTypographyStylesV2 } from 'breadcrumbs-ui/components/Text';
import { getAccountMenuItemPadding } from '../../../components/Accounts/shared-styles';
import { getAccountMenuBorder } from '../../../components/Accounts/shared-styles';
import { useAppDispatch } from '../../../hooks';
import { setShowThemeSwitchConfirmationModal } from '../../../reducers/Trellis';
import { useTranslation } from '../../../hooks/useNavConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMenuItem = styled(MenuItem)(({
  theme
}) => css(_t || (_t = _`
    list-style-type: none !important;

    border-bottom: ${0} !important;
    padding: ${0} !important;
    display: block;
    position: relative;
    color: ${0} !important;
    background-color: ${0};

    &:hover {
      background-color: ${0};
    }
  `), getAccountMenuBorder(theme), getAccountMenuItemPadding(theme), theme.color['text-core-default'], theme.color['fill-surface-default'], theme.color['fill-field-hover']));
const TrellisOptLinkContainer = styled.div.withConfig({
  displayName: "TrellisOptButton__TrellisOptLinkContainer",
  componentId: "ya6pmr-0"
})(["display:flex;gap:", ";color:", " !important;", " text-align:left;&:hover{text-decoration:underline;}"], ({
  theme
}) => theme.space['50'], ({
  theme
}) => theme.color['text-core-default'], ({
  theme
}) => getTypographyStylesV2(theme, 'body-125'));
const TrellisOptButton = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const {
    t
  } = useTranslation();
  const isTrellis = useMemo(() => {
    return isTrellisTheme(theme);
  }, [theme]);
  const handleToggle = () => {
    dispatch(setShowThemeSwitchConfirmationModal(true));
  };
  const linkText = isTrellis ? t('nav.trellis.switchToClassicTheme') : t('nav.trellis.switchToNewTheme');
  return /*#__PURE__*/_jsx(StyledMenuItem, {
    onClick: handleToggle,
    type: "button",
    children: /*#__PURE__*/_jsx(TrellisOptLinkContainer, {
      children: linkText
    })
  });
};
export default TrellisOptButton;